/* SEDEA — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.sd-reveal:not(.sd-visible)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('sd-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('sd-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Barra fija: aparece cuando el botón principal sale de la pantalla */
  function initSticky() {
    var bar = document.querySelector('[data-sd-sticky]');
    var ancla = document.querySelector('[data-sd-sticky-ancla]');
    if (!bar || !ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(ancla);
  }

  /* Galería deslizable: flechas + puntos */
  function initGalerias(root) {
    (root || document).querySelectorAll('[data-sd-galeria]').forEach(function (g) {
      if (g.__sd) return; g.__sd = true;
      var track = g.querySelector('[data-sd-track]');
      var slides = track ? track.children : [];
      var dots = g.querySelectorAll('[data-sd-dots] span');
      if (!track || !slides.length) return;
      function paso() { return slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 12); }
      var prev = g.querySelector('[data-sd-prev]'), next = g.querySelector('[data-sd-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: reduce ? 'auto' : 'smooth' }); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / paso());
          var max = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= max - 4) i = slides.length - 1;
          dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        }, 60);
      }, { passive: true });
    });
  }

  /* Línea de entrega: fechas desde hoy, contando solo lunes a viernes */
  function initEntrega(root) {
    (root || document).querySelectorAll('[data-sd-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 5;
      var max = Math.max(parseInt(el.getAttribute('data-max'), 10) || 8, min);
      function sumarHabiles(fecha, n) {
        var d = new Date(fecha);
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      function fmt(d) { return d.getDate() + ' ' + d.toLocaleDateString('es-CL', { month: 'short' }).replace('.', ''); }
      var hoy = new Date();
      var a = sumarHabiles(hoy, min), b = sumarHabiles(hoy, max);
      var h = el.querySelector('[data-sd-fecha="hoy"]');
      var r = el.querySelector('[data-sd-fecha="rango"]');
      if (h) h.textContent = 'Hoy, ' + fmt(hoy);
      if (r) r.textContent = (a.getMonth() === b.getMonth() ? a.getDate() : fmt(a)) + '–' + fmt(b);
    });
  }

  /* "Llega a más tardar el …" junto al precio */
  function initLlega(root) {
    (root || document).querySelectorAll('[data-sd-llega]').forEach(function (el) {
      var max = parseInt(el.getAttribute('data-max'), 10) || 8;
      var d = new Date();
      while (max > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) max--; }
      var b = el.querySelector('[data-sd-fecha="llega"]');
      if (b) b.textContent = 'llega a más tardar el ' + d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' });
    });
  }

  /* Cantidad + "Comprar": vacía el carrito y agrega la cantidad elegida, así nunca se duplica */
  var MAX_CANT = 5;
  function cantidad() {
    var n = document.querySelector('[data-sd-qty-num]');
    return n ? parseInt(n.textContent, 10) || 1 : 1;
  }
  function ponerCantidad(n) {
    n = Math.min(Math.max(n, 1), MAX_CANT);
    document.querySelectorAll('[data-sd-qty]').forEach(function (q) {
      q.querySelector('[data-sd-qty-num]').textContent = n;
      q.querySelector('[data-sd-qty-menos]').disabled = n <= 1;
      q.querySelector('[data-sd-qty-mas]').disabled = n >= MAX_CANT;
    });
    document.querySelectorAll('[data-sd-cantidad]').forEach(function (i) { i.value = n; });
    document.querySelectorAll('[data-sd-pack]').forEach(function (b) { b.classList.toggle('is-activo', n >= parseInt(b.getAttribute('data-sd-pack'), 10)); });
  }
  function initCompra() {
    document.querySelectorAll('[data-sd-qty]').forEach(function (q) {
      if (q.__sd) return; q.__sd = true;
      q.querySelector('[data-sd-qty-menos]').addEventListener('click', function () { ponerCantidad(cantidad() - 1); });
      q.querySelector('[data-sd-qty-mas]').addEventListener('click', function () { ponerCantidad(cantidad() + 1); });
      ponerCantidad(1);
    });
    document.querySelectorAll('[data-sd-pack]').forEach(function (b) {
      if (b.__sd) return; b.__sd = true;
      b.addEventListener('click', function () { ponerCantidad(parseInt(b.getAttribute('data-sd-pack'), 10) || 2); });
    });
    document.querySelectorAll('form[data-sd-compra="true"]').forEach(function (f) {
      if (f.__sd) return; f.__sd = true;
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (f.__enviando) return; f.__enviando = true;
        var btn = f.querySelector('[type="submit"]'); if (btn) btn.setAttribute('aria-busy', 'true');
        var id = f.querySelector('[name="id"]').value;
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: cantidad() }] }) });
          })
          .then(function (r) { if (!r.ok) throw r; window.location.href = '/checkout'; })
          .catch(function () { f.__enviando = false; f.submit(); });
      });
    });
  }

  /* Test "¿Es para ti?": vello y piel definen el resultado; tatuajes o lunares solo agregan un consejo */
  var TEST_RES = {
    ok: ['¡SEDEA es para ti!', 'Tu vello y tu piel son la combinación ideal para la luz pulsada. Con constancia, el vello vuelve cada vez más lento: depílate en casa, a tu ritmo y sin pagar sesiones.'],
    medio: ['SEDEA también es para ti', 'Tu combinación responde a la luz pulsada. Parte en el nivel 1, sube a tu ritmo y sé constante con tus sesiones: depílate en casa, sin citas ni traslados.'],
    no: ['Preferimos ser honestos contigo', 'La luz pulsada necesita contraste entre el vello y la piel. Con tu combinación lo más probable es que no veas resultados, por eso no te la recomendamos.']
  };
  var TEST_ZONA = ' Tip: sáltate los tatuajes y lunares al aplicar.';
  function initTest(root) {
    (root || document).querySelectorAll('[data-sd-test]').forEach(function (t) {
      if (t.__sd) return; t.__sd = true;
      var grupos = t.querySelectorAll('.sd-test__preg');
      var res = t.querySelector('[data-sd-test-res]');
      t.addEventListener('change', function () {
        var valores = [];
        grupos.forEach(function (g) { var m = g.querySelector('input:checked'); if (m) valores.push(m.value); });
        if (valores.length < grupos.length) return;
        var base = valores.slice(0, 2);
        var r = base.indexOf('no') > -1 ? 'no' : (base.indexOf('medio') > -1 ? 'medio' : 'ok');
        var texto = TEST_RES[r][1] + (r !== 'no' && valores[2] === 'medio' ? TEST_ZONA : '');
        res.hidden = false;
        res.className = 'sd-test__res is-' + r;
        t.querySelector('[data-sd-test-titulo]').textContent = TEST_RES[r][0];
        t.querySelector('[data-sd-test-texto]').textContent = texto;
        t.querySelector('[data-sd-test-cta]').hidden = r === 'no';
      });
    });
  }

  /* Video: botón para activar o silenciar el sonido */
  function initVideo(root) {
    (root || document).querySelectorAll('[data-sd-video]').forEach(function (m) {
      if (m.__sd) return; m.__sd = true;
      var vid = m.querySelector('video'), btn = m.querySelector('[data-sd-video-sonido]');
      if (!vid || !btn) return;
      btn.addEventListener('click', function () {
        vid.muted = !vid.muted;
        if (!vid.muted) { vid.currentTime = 0; vid.play(); }
        btn.setAttribute('aria-pressed', String(!vid.muted));
        btn.textContent = vid.muted ? 'Activar sonido' : 'Silenciar';
      });
    });
  }

  function initAll(root) { initReveals(root); initSticky(); initGalerias(root); initEntrega(root); initLlega(root); initCompra(); initTest(root); initVideo(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
